export const CPF_LENGTH = 11;
export const CNPJ_LENGTH = 14;

export const CPF_MASK = '999.999.999-99';
export const CNPJ_MASK = '99.999.999/9999-99';

export const CPF_LABEL = 'CPF';
export const CNPJ_LABEL = 'CNPJ';

const cpfRegex = /^(\d{3})[\.]?(\d{3})[\.]?(\d{3})[\-]?(\d{2})$/;
const cnpjRegex = /^(\d{2})[\.]?(\d{3})[\.]?(\d{3})[\/]?(\d{4})[-]?(\d{2})$/;

function isCpf(input) {
  return !!input.match(cpfRegex);
}

function isCnpj(input) {
  return !!input.match(cnpjRegex);
}

function unmask(input) {
  return input.replace(/\D/g, '');
}

export const getDocumentType = (document) => {
  if (isCpf(document)) return CPF_LABEL;
  if (isCnpj(document)) return CNPJ_LABEL;

  return '';
};

export const getAccountType = (document) => {
  if (isCpf(document)) return 'Pessoa Física';
  if (isCnpj(document)) return 'Pessoa Jurídica';

  return '';
};

export default {
  isCpf,
  isCnpj,
  unmask
};
